<template>
  <div class="product-info x-margin x-border-50" data-automation="productInfo">
    <my-head-title :title="$t('HT.accessInfo.title')"></my-head-title>
    <div class="ul-item x-padding-info">
      <my-info-item :title="$t('HT.unbindApi.name')" :info="formData.name"></my-info-item>
      <my-info-item :title="$t('HT.productAll.type')">
        <span>{{ $opt.switchStr(formData.type, $opt.productType) }}</span>
      </my-info-item>
      <my-info-item :title="$t('HT.createdTime')" :info="formData.created_date"></my-info-item>
      <my-info-item :title="$t('HT.addProduct.remark')" start :info="formData.remark"></my-info-item>
    </div>
    <div class="info-content x-padding-x">
      <el-button plain size="small" @click="generateApi" class="api_words">{{$t('HT.router.productList.api')}}</el-button>
      <div class="tab" v-if="isShow == true">
        <ux-table
          ref="table"
          :showPage="false"
          :data="tableData.list"
          :total="tableData.totalSize"
          :columns="columns1"
          :emptyText="$t('HT.nodata')"
          layout="total, sizes, prev, pager, next"
        ></ux-table>
      </div>
      <div class="tab" v-else>
        <ux-table
          ref="table"
          :showPage="false"
          :data="tableData.list"
          :total="tableData.totalSize"
          :emptyText="$t('HT.nodata')"
          :columns="columns2"
          layout="total, sizes, prev, pager, next"
        ></ux-table>
      </div>
    </div>
  </div>
</template>

<script>
import addProduct from './template/addProduct';
export default {
  components: {
    addProduct
  },
  data() {
    return {
      isShow: true,
      id: this.$route.query.id, // 产品id
      formData: {
        // 详情数据
      },
      // 表的数据
      tableData: {
        totalSize: 0,
        list: []
      },
      columns1: [
        // 表格项
        {
          label: this.$t('HT.apiStepOne.name'),
          tooltip: true,
          prop: 'name'
        },
        {
          label: this.$t('HT.upgrade.type'),
          tooltip: true,
          prop: 'type'
        },
        {
          label: this.$t('HT.operation'),
          hidden: false,
          render: (h, params) => {
            return h('my-table-btn', {
              props: {
                data: ['⬆️', '⬇️'],
                colors: ['#0087ff'],
                event: ['tabUp', 'tabDown']
              },
              on: {
                tabUp: () => {
                  this.tabUp(params);
                },
                tabDown: () => {
                  this.tabDown(params);
                }
              }
            });
          }
        }
      ],
      columns2: [
        // 表格项
        {
          label: this.$t('HT.apiStepOne.name'),
          tooltip: true,
          prop: 'name'
        },
        {
          label: this.$t('HT.upgrade.type'),
          tooltip: true,
          prop: 'type'
        },
        {
          label: this.$t('HT.operation'),
          hidden: false,
          render: (h, params) => {
            return h('my-table-btn', {
              props: {
                data: [this.$t('HT.debug')],
                colors: ['#0087ff'],
                event: ['deBugging']
              },
              on: {
                deBugging: () => {
                  this.deBugging(params);
                }
              }
            });
          }
        }
      ]
    };
  },

  created() {
    this.getInfoList(this.id);
    this.getInfo(this.id);
    this.getSupervisor();
  },
  methods: {
    // API文档
    generateApi() {
      this.$router.push({
        name: 'generateApi',
        query: {
          id: this.id
        }
      });
    },
    /**
     * 方法
     * @param {Object} params 跳转到调试页面
     */
    deBugging(debugData) {
      this.$router.push({
        name: 'debug3',
        query: {
          params: JSON.stringify(debugData),
          flag: true
        }
      });
    },
    /**
     * 获取超级管理员字段
     * @param {String}
     */
    getSupervisor() {
      this.isShow = JSON.parse(localStorage.getItem('userData')).supervisor;
    },

    /**
     * @description: row上移
     * @param {Object} : params 表的一条数据
     */
    tabUp(params) {
      const { id, type, api_or_group_id, order, index } = params;
      // 第一个 跳出
      if (index == 0) {
        return;
      }
      this.$api.product
        .sortList({
          aog_arr: {
            id,
            type,
            api_or_group_id,
            order
          },
          status: 1
        })
        .then((res) => {
          if (res.code === 10000) {
            this.getInfoList(this.formData.id);
          }
        });
    },
    /**
     * @description: row下移
     * @param {Object} :params 表的一条数据
     */
    tabDown(params) {
      const { id, type, api_or_group_id, order, index } = params;
      // 最后一个 跳出
      if (index == this.tableData.totalSize - 1) {
        return;
      }
      this.$api.product
        .sortList({
          aog_arr: {
            id,
            type,
            api_or_group_id,
            order
          },
          status: 0
        })
        .then((res) => {
          if (res.code === 10000) {
            this.getInfoList(this.formData.id);
          }
        });
    },

    getInfo(params) {
      this.$uxLoading.show();
      this.$api.product.getInfo(params).then((res) => {
        if (res.code == 10000) {
          this.formData = res.data;
        }
      });
    },
    /**
     * 管理 ->产品明细页面数据
     * @param {Object} params 表单参数
     */
    getInfoList(params) {
      this.$uxLoading.show();
      this.$api.product.getInfoList(params).then((res) => {
        if (res.code == 10000) {
          this.tableData = {
            totalSize: res.total_size,
            list: res.data
          };
        }
      });
    },
    /**
     * 产品绑定API/API分组
     */
    setApigroup(data) {
      this.$api.product
        .setApigroup(this.formData.id, {
          aog_arr: data
        })
        .then((res) => {
          if (res.code === 10000) {
            this.$uxModal.hide();
            this.$uxMessage.success(this.$t('HT.addApi.bindSuccess'));
            this.getInfoList(this.formData.id);
          }
        });
    },

    /**
     * 修改列表
     * @param {Number} id 唯一标识
     * @param {Object} params 表单提交参数
     */
    putList(params) {
      this.$uxLoading.show();
      this.$api.product.putList(params).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.editSuccess'));
          this.getInfo(this.id);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.product-info {
  padding-bottom: 20px;
  .info-content {
    .api_words {
      margin: 0 0 10px 0;
    }
  }
}
</style>
